<script setup lang="ts">
import HouseHoldApplianceIcon from '~/components/HouseHoldAppliances/HouseHoldApplianceIcon.vue'
import type { HouseHoldApplianceType } from '~/types';

const props = withDefaults(
  defineProps<{
    label?: string,
    icon: HouseHoldApplianceType | string,
    size?: number,
    value?: boolean,
    disabled?: boolean,
  }>(),
  { size: 20 }
)

const style = computed(() => {
  const classList: string[] = [
    'transition-colors',
    'duration-300',
    'ease-in-out'
  ]

  if (props.value) {
    classList.push('bg-primary hover:bg-primary')
  } else {
    classList.push('bg-neutral hover:bg-primary/60')
  }

  if (props.disabled) {
    classList.push('opacity-50 cursor-not-allowed')
  }

  return classList.join(' ')
})
</script>

<template>
  <button
    class="group/rich-check-box flex items-center justify-center aspect-square rounded-full focus-visible:ring-2 focus-visible:ring-current focus-visible:ring-offset-2"
    :class="{
      [style]: true,
      [`h-${size} w-${size}`]: true,
    }" type="button" :aria-label="label" :aria-pressed="value" :aria-disabled="disabled ? 'true' : undefined">
    <HouseHoldApplianceIcon :icon="icon" :label="label" :size="10" :active="value" />
  </button>
</template>